import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const VersionEmptyState = {
  versions: [],
  selectedVersion: null,
};

export const VersionKey = 'versions';

export const versionsSlice = createSlice({
  name: 'versions',
  initialState: getLocalStorage(LocalStorageTypes.VERSIONS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.VERSIONS))
    : VersionEmptyState,
  reducers: {
    setVersions: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.VERSIONS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedVersion: (state, action) => {
      const result = { ...state, selectedVersion: action.payload };
      persistLocalStorage(VersionKey, result);
      return result;
    },
    resetVersions: () => {
      clearLocalStorage('versions');
      return VersionEmptyState;
    },
  },
});

export const { setVersions, updateSelectedVersion, resetVersions } =
  versionsSlice.actions;
